<cam-form
  [inputs]="this.form()"
  [askValidation$]="this.askValidation()"
  [canDisplayButton]="false"
  [error]="this.error()"
  [loader]="this.loader()"
  (isFormValid)="this.isFormValid.emit($event)"
  (valid)="this.validation($event)"
></cam-form>

<ng-template #typeTemplate let-item="item" [typedTemplate]="this.typeTypeToken">
  <div class="g-space-sm">
    {{ item }}
  </div>
</ng-template>
